<template lang="pug">
.case_components
  v-tabs.mt-4(fixed-tabs="")
    v-tab Templates
    v-tab Checks
    v-tab-item
      Templates(:checks="checks")
    v-tab-item
      Checks(:data="checks")
</template>
<script>
import Templates from "@/components/Admin/CaseDocuments/Templates/index";
import Checks from "@/components/Admin/CaseDocuments/Checks/index";
export default {
  components: { Templates, Checks },
  data() {
    return {
      checks: [],
    };
  },
  mounted() {
    this.refreshChecks();
  },
  methods: {
    refreshChecks() {
      this.axios
        .get("/admin/documents/check")
        .then((resp) => {
          this.checks = resp.data;
        })
        .catch((e) => {
          this.$message.errorFromServer(e);
        });
    },
  },
};
</script>